import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import modulAuth from "./moduls/Auth/init/store";
import modulSessionMethodVideoModul from "./moduls/SessionMethodVideoModul/init/store";
import modulRecording from "./moduls/RecordingModul/init/store";
import webSocketReducers from "./general/components/websocket/reducers";
import modulWaitingRoom from "./moduls/WaitingRoomModul/init/store";
import generalStore from "./general/init/store";
import modulKonselor from "./moduls/PduliModul/init/store";

const reducerGeneral = {
  // name: reducersName,
};

const allReducerConst = Object.assign(
  generalStore,
  webSocketReducers,
  reducerGeneral,
  modulAuth,
  modulSessionMethodVideoModul,
  modulRecording,
  modulWaitingRoom,
  modulKonselor
);
const reducer = combineReducers(allReducerConst);

const userInfoFromStorage = localStorage.getItem("token")
  ? localStorage.getItem("token")
  : null;
const initialState = {
  // userLogin: { token: userInfoFromStorage },
  // addressmodul_get_token: { tad: tokenAddress },
};

const middleware = [thunk];
const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);
// console.log("store", store.getState());
export default store;
